import { render, staticRenderFns } from "./AmeliaRevTranscript.vue?vue&type=template&id=55932749"
import script from "./AmeliaRevTranscript.vue?vue&type=script&lang=js"
export * from "./AmeliaRevTranscript.vue?vue&type=script&lang=js"
import style0 from "./AmeliaRevTranscript.vue?vue&type=style&index=0&id=55932749&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports